// extracted by mini-css-extract-plugin
export default {"box":"commentdetail_box__cLYrd"};